export default __webpack_public_path__ + "static/media/kabupaten-gorontalo-utara.3a6fc90a.png";